<template>
 
        <img 
                    :src="mediaPath"
                    :alt="item.title"
                    :class="checkClass()"
                    :style="imageStyle"
                />
  
</template>

<script>
export default {

    name: "Outfit",
    props: {
        item: {
            type: Object,
            required: true,
            default: () => ({
                title: '',
                image: {
                    src: ''
                },
                class: ''
            })
        },
        outfitItems: {
            type: Array,
            default: () => [],
        },
        style: ""
    },
   
    data() {
        return {
           
        };
    },
    mounted() {
       
    },
    methods: {
       checkClass() {
        if (this.item.class === 'ppe_doll') {
            return 'ppe_doll';
       }else if (this.item.class === 'ppe_women_doll') {
            return 'ppe_women_doll';
       } else {
        return this.item.class;
       }
    },

    
},
computed: {
       mediaPath() {
         return app.api.Utils.getMediaPath(this.item.image.src); 
       },
       imageStyle() {
        if (this.item.class !== 'ppe_doll' && this.item.class !== 'ppe_women_doll') {
            const isInOutfit = this.outfitItems.some(outfit => outfit.title === this.item.title);
            return {
                display: isInOutfit ? 'block' : 'none',
            };
        } 
        
       },
    }
};

</script>

<style lang="scss" scoped>

</style>